"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LengthUnit;
(function (LengthUnit) {
    LengthUnit["Pixel"] = "px";
    LengthUnit["Point"] = "pt";
    LengthUnit["Inch"] = "in";
    LengthUnit["Centimeter"] = "cm";
})(LengthUnit = exports.LengthUnit || (exports.LengthUnit = {}));
//# sourceMappingURL=length-unit.js.map